import axios from 'axios';
import {API} from '../config';

axios.defaults.headers.post['Access-Control-Allow-Origin'] = "*";
axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';

class CargaSelecaoService {
  
  getGeneros(){
    return axios.get(API + "/generos")
  }

  getRacasCores(){
    return axios.get(API + "/raca-cor")
  }

  getTiposSanguineos(){
    return axios.get(API + "/tipos-sanguineos")
  }
}

const instanceCargaSelecao = new CargaSelecaoService();
export default instanceCargaSelecao;
